module.exports = __webpack_public_path__ + "img/logo.2c418983.png";